// extracted by mini-css-extract-plugin
export var li = "_vo-2";
export var ol = "_vo-1";
export var ul = "_vo-0";